import React, { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { isNull } from '../../../../../predicates/type';
import { PublicJobDetailBox } from '../PublicJobDetailBox';
import { Typography } from '../../../../../components/Typography';
import { FlexGrid, FlexGridColumn } from '../../../../../components/FlexGrid';
import { PublicJobDetailContactDataItem } from './PublicJobDetailContactDataItem';
import { PaddingBox } from '../../../../../components/PaddingBox';
import { useTranslationAPI } from '../../../../translations';
import { jobModuleCodes } from '../../../../../data/translations/jobModuleCodes';
import { PhoneUp } from '../../../../../components/Icons/PhoneUp';
import { EnvelopeO } from '../../../../../components/Icons/EnvelopeO';
import { LinkedIn } from '../../../../../components/Icons/LinkedIn';
import { QuestionCircleO } from '../../../../../components/Icons/QuestionCircleO';
import { gray } from '../../../../../components/Color';

export const PublicJobDetailContact: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: { jobContact },
	} = usePublicJobDetailDataQuery();

	if (isNull(jobContact)) return null;

	const { showEmail, showPhone, showPhoto, showName, showLinkedIn, phone, photoUrl, email, linkedIn } = jobContact;

	if (!showEmail && !showPhone && !showPhoto && !showName) return null;

	return (
		<PublicJobDetailBox>
			<PaddingBox bottomTiny>
				<FlexGrid
					gap='tiny'
					center
				>
					<QuestionCircleO
						width={24}
						height={24}
						fill={gray[6]}
					/>
					<Typography bold>{translate(jobModuleCodes.jobContactTitle)}</Typography>
				</FlexGrid>
			</PaddingBox>
			<FlexGrid
				gap='small'
				bottom
			>
				<FlexGridColumn
					grow
					wrappedText
				>
					<FlexGrid
						gap='scanty'
						column
					>
						{showName && <Typography bold>{jobContact.name}</Typography>}
						{showPhone && (
							<PublicJobDetailContactDataItem
								icon={PhoneUp}
								href={`tel:${phone.number}`}
								value={phone.number}
							/>
						)}
						{showEmail && (
							<PublicJobDetailContactDataItem
								icon={EnvelopeO}
								value={email}
								href={`mailto:${email}`}
							/>
						)}
						{showLinkedIn && (
							<PublicJobDetailContactDataItem
								icon={LinkedIn}
								value={linkedIn}
							/>
						)}
					</FlexGrid>
				</FlexGridColumn>
				{showPhoto && photoUrl && (
					<FlexGridColumn
						noShrink
						noGrow
						flexBasis='64px'
					>
						<img
							src={photoUrl}
							alt='job contact logo url'
						/>
					</FlexGridColumn>
				)}
			</FlexGrid>
		</PublicJobDetailBox>
	);
};
